var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1H4C2.34315 1 1 2.34315 1 4V12C1 13.6569 2.34315 15 4 15H12C13.6569 15 15 13.6569 15 12V4C15 2.34315 13.6569 1 12 1Z",
    fill: "url(#paint0_radial_16948_2505)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1H4C2.34315 1 1 2.34315 1 4V12C1 13.6569 2.34315 15 4 15H12C13.6569 15 15 13.6569 15 12V4C15 2.34315 13.6569 1 12 1Z",
    fill: "url(#paint1_radial_16948_2505)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1H4C2.34315 1 1 2.34315 1 4V12C1 13.6569 2.34315 15 4 15H12C13.6569 15 15 13.6569 15 12V4C15 2.34315 13.6569 1 12 1Z",
    fill: "url(#paint2_radial_16948_2505)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.25C11.5 5.6642 11.1642 6 10.75 6C10.3358 6 10 5.6642 10 5.25C10 4.83579 10.3358 4.5 10.75 4.5C11.1642 4.5 11.5 4.83579 11.5 5.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.5C9.3807 10.5 10.5 9.3807 10.5 8C10.5 6.6193 9.3807 5.5 8 5.5C6.6193 5.5 5.5 6.6193 5.5 8C5.5 9.3807 6.6193 10.5 8 10.5ZM8 9.5C8.82845 9.5 9.5 8.82845 9.5 8C9.5 7.17155 8.82845 6.5 8 6.5C7.17155 6.5 6.5 7.17155 6.5 8C6.5 8.82845 7.17155 9.5 8 9.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.8C3 6.11985 3 5.27975 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27975 3 6.11985 3 7.8 3H8.2C9.88015 3 10.7203 3 11.3619 3.32698C11.9264 3.6146 12.3854 4.07354 12.673 4.63803C13 5.27975 13 6.11985 13 7.8V8.2C13 9.88015 13 10.7203 12.673 11.3619C12.3854 11.9264 11.9264 12.3854 11.3619 12.673C10.7203 13 9.88015 13 8.2 13H7.8C6.11985 13 5.27975 13 4.63803 12.673C4.07354 12.3854 3.6146 11.9264 3.32698 11.3619C3 10.7203 3 9.88015 3 8.2V7.8ZM7.8 4H8.2C9.0566 4 9.63885 4.00078 10.089 4.03755C10.5274 4.07337 10.7516 4.1383 10.908 4.21799C11.2843 4.40974 11.5903 4.7157 11.782 5.092C11.8617 5.2484 11.9267 5.4726 11.9625 5.91105C11.9992 6.36115 12 6.9434 12 7.8V8.2C12 9.0566 11.9992 9.63885 11.9625 10.089C11.9267 10.5274 11.8617 10.7516 11.782 10.908C11.5903 11.2843 11.2843 11.5903 10.908 11.782C10.7516 11.8617 10.5274 11.9267 10.089 11.9625C9.63885 11.9992 9.0566 12 8.2 12H7.8C6.9434 12 6.36115 11.9992 5.91105 11.9625C5.4726 11.9267 5.2484 11.8617 5.092 11.782C4.7157 11.5903 4.40974 11.2843 4.21799 10.908C4.1383 10.7516 4.07337 10.5274 4.03755 10.089C4.00078 9.63885 4 9.0566 4 8.2V7.8C4 6.9434 4.00078 6.36115 4.03755 5.91105C4.07337 5.4726 4.1383 5.2484 4.21799 5.092C4.40974 4.7157 4.7157 4.40974 5.092 4.21799C5.2484 4.1383 5.4726 4.07337 5.91105 4.03755C6.36115 4.00078 6.9434 4 7.8 4Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16948_2505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6 11.5) rotate(-55.3758) scale(12.7598)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_16948_2505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.5 15.5) rotate(-65.1363) scale(11.2971)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_16948_2505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.25 1.5) rotate(-8.1301) scale(19.4455 4.15918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9f7f5922cbbb887683efc9f920bb4dde.svg";
export { ForwardRef as ReactComponent };